export const FLEET_LABEL = {
  internal: 'bg-emerald-50 text-emerald-800 border-emerald-300',
  external: 'bg-indigo-50 text-indigo-800 border-indigo-300',
};

export const fleetParam = (sel) => (sel.internal && sel.external ? undefined : sel.internal ? 'internal' : 'external');

export const FleetBadge = ({ fc, testId }) => {
  const c = fc === 'internal' ? 'internal' : 'external';
  return (
    <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wider border ${FLEET_LABEL[c]}`} data-testid={testId}>
      {c}
    </span>
  );
};

export const FleetTicks = ({ value, onChange }) => {
  const toggle = (k) => {
    const next = { ...value, [k]: !value[k] };
    if (!next.internal && !next.external) return; // keep at least one ticked
    onChange(next);
  };
  return (
    <div className="flex items-center gap-3 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm" data-testid="fleet-ticks">
      {[['internal', 'Internal fuel'], ['external', 'External fuel']].map(([k, label]) => (
        <label key={k} className="flex items-center gap-1.5 cursor-pointer select-none text-slate-800">
          <input type="checkbox" checked={value[k]} onChange={() => toggle(k)} className={k === 'internal' ? 'accent-emerald-600' : 'accent-indigo-600'} data-testid={`fleet-tick-${k}`} />
          {label}
        </label>
      ))}
    </div>
  );
};
